'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.anyClusterSide = exports.clusterTopAndBottom = exports.topAndBottom = undefined;

var _rect = require('./geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _documentOrderAlgorithmConstants = require('./documentOrderAlgorithmConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var topAndBottom = exports.topAndBottom = function topAndBottom(rect1, rect2) {
    return rectLib.isVerticallyInline(rect1, rect2, _documentOrderAlgorithmConstants.COLUMN_OVERLAP_THRESHOLD) ? _documentOrderAlgorithmConstants.AUTO_COLUMN_DISTANCE : _documentOrderAlgorithmConstants.MAX_DIST_BETWEEN_BOTTOM_AND_TOP;
};

// Constants
var clusterTopAndBottom = exports.clusterTopAndBottom = function clusterTopAndBottom(cluster1, cluster2) {
    return topAndBottom(cluster1.bounds, cluster2.bounds);
};

// √
var adjustForCategory = function adjustForCategory(cat1, cat2, dist, adjustment) {
    return cat1 === cat2 ? adjustment(cat1) * dist : dist;
};
var adjustForColor = function adjustForColor(cluster1, cluster2, dist) {
    return adjustForCategory(cluster1.color, cluster2.color, dist, function () {
        return _documentOrderAlgorithmConstants.SAME_COLOR_ADJUSTMENT;
    });
};
var adjustForType = function adjustForType(cluster1, cluster2, dist) {
    return adjustForCategory(cluster1.type, cluster2.type, dist, function (type) {
        return _documentOrderAlgorithmConstants.SAME_TYPE_ADJUSTMENTS[type] || 1;
    });
};

var clusterAdjustmentsPipeline = [adjustForColor, adjustForType];
var anyClusterSide = exports.anyClusterSide = function anyClusterSide(cluster1, cluster2) {
    var dist = rectLib.distanceFromAnySide(cluster1.bounds, cluster2.bounds);
    return clusterAdjustmentsPipeline.reduce(function (adjustedDist, adjustmentFn) {
        return adjustmentFn(cluster1, cluster2, adjustedDist);
    }, dist);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/clusterDistance.js
// module id = 2258
// module chunks = 0